import { render, staticRenderFns } from "./drawerAppointment.vue?vue&type=template&id=d70e05bc&"
import script from "./drawerAppointment.vue?vue&type=script&lang=js&"
export * from "./drawerAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports